var map = {
	"./S1.svg": [
		85126,
		85126
	],
	"./T.svg": [
		45634,
		45634
	],
	"./activity-feed-fill.svg": [
		23512,
		23512
	],
	"./activity-feed.svg": [
		23254,
		23254
	],
	"./apple-logo.svg": [
		68430,
		68430
	],
	"./apple.svg": [
		74670,
		74670
	],
	"./arrow-back-circle.svg": [
		53848,
		53848
	],
	"./arrow-back-square.svg": [
		27521,
		27521
	],
	"./arrow-back.svg": [
		75547,
		75547
	],
	"./arrow-double-horizontal.svg": [
		83958,
		83958
	],
	"./arrow-double-vertical-2.svg": [
		74033,
		74033
	],
	"./arrow-double-vertical.svg": [
		96844,
		96844
	],
	"./arrow-down-circle-fill.svg": [
		22079,
		22079
	],
	"./arrow-down-circle.svg": [
		9235,
		9235
	],
	"./arrow-down-left.svg": [
		6784,
		6784
	],
	"./arrow-down-right.svg": [
		33967,
		33967
	],
	"./arrow-down-square.svg": [
		15890,
		15890
	],
	"./arrow-down.svg": [
		28534,
		28534
	],
	"./arrow-left-circle-fill.svg": [
		11460,
		11460
	],
	"./arrow-left-circle.svg": [
		30794,
		30794
	],
	"./arrow-left-square.svg": [
		4655,
		4655
	],
	"./arrow-left.svg": [
		18717,
		18717
	],
	"./arrow-right-circle-fill.svg": [
		95417,
		95417
	],
	"./arrow-right-circle.svg": [
		44845,
		44845
	],
	"./arrow-right-square.svg": [
		30592,
		30592
	],
	"./arrow-right.svg": [
		72288,
		72288
	],
	"./arrow-up-circle-fill.svg": [
		32020,
		32020
	],
	"./arrow-up-circle.svg": [
		10618,
		10618
	],
	"./arrow-up-left.svg": [
		85841,
		85841
	],
	"./arrow-up-line.svg": [
		49084,
		49084
	],
	"./arrow-up-right.svg": [
		49244,
		49244
	],
	"./arrow-up-square.svg": [
		82399,
		82399
	],
	"./arrow-up.svg": [
		44109,
		44109
	],
	"./arrows-omni.svg": [
		72786,
		72786
	],
	"./assessment.svg": [
		50372,
		50372
	],
	"./at-sign.svg": [
		63349,
		63349
	],
	"./audio-off.svg": [
		27604,
		27604
	],
	"./audio.svg": [
		96848,
		96848
	],
	"./avatar-circle-fill.svg": [
		34188,
		34188
	],
	"./avatar-circle.svg": [
		86402,
		86402
	],
	"./avatar-fill.svg": [
		25457,
		25457
	],
	"./avatar-lock-circle.svg": [
		64336,
		64336
	],
	"./avatar-lock-square.svg": [
		60473,
		60473
	],
	"./avatar-lock.svg": [
		65043,
		65043
	],
	"./avatar-plus-circle.svg": [
		32731,
		32731
	],
	"./avatar-plus-square-fill.svg": [
		35188,
		35188
	],
	"./avatar-plus-square.svg": [
		6810,
		6810
	],
	"./avatar-plus.svg": [
		70974,
		70974
	],
	"./avatar-square-fill.svg": [
		83547,
		83547
	],
	"./avatar-square.svg": [
		97383,
		97383
	],
	"./avatar-stack-fill.svg": [
		68324,
		68324
	],
	"./avatar-stack-plus-fill.svg": [
		75967,
		75967
	],
	"./avatar-stack.svg": [
		35786,
		35786
	],
	"./avatar.svg": [
		60501,
		60501
	],
	"./avatars-square.svg": [
		11180,
		11180
	],
	"./award.svg": [
		69377,
		69377
	],
	"./badge-check.svg": [
		85464,
		85464
	],
	"./badge-edit.svg": [
		27108,
		27108
	],
	"./badge-eye.svg": [
		80303,
		80303
	],
	"./badge-key.svg": [
		99405,
		99405
	],
	"./badge-notification.svg": [
		63725,
		63725
	],
	"./badge-smile.svg": [
		27716,
		27716
	],
	"./badge-star-fill.svg": [
		44874,
		44874
	],
	"./badge-star.svg": [
		94976,
		94976
	],
	"./bar-chart-2.svg": [
		67999,
		67999
	],
	"./bar-chart.svg": [
		70678,
		70678
	],
	"./battery-charging.svg": [
		33611,
		33611
	],
	"./battery.svg": [
		99117,
		99117
	],
	"./bell-fill.svg": [
		37261,
		37261
	],
	"./bell-off-fill.svg": [
		74521,
		74521
	],
	"./bell-off.svg": [
		49357,
		49357
	],
	"./bell.svg": [
		58681,
		58681
	],
	"./block-fill.svg": [
		31445,
		31445
	],
	"./block-notification-fill.svg": [
		75119,
		75119
	],
	"./block-notification.svg": [
		38915,
		38915
	],
	"./block.svg": [
		20689,
		20689
	],
	"./bluetooth.svg": [
		25560,
		25560
	],
	"./bold.svg": [
		75963,
		75963
	],
	"./bolt-circle-fill.svg": [
		55234,
		55234
	],
	"./bolt-fill.svg": [
		31879,
		31879
	],
	"./bolt-square-fill.svg": [
		59253,
		59253
	],
	"./bolt.svg": [
		81291,
		81291
	],
	"./book-fill.svg": [
		70861,
		70861
	],
	"./book-open.svg": [
		58374,
		58374
	],
	"./book.svg": [
		30233,
		30233
	],
	"./bookmark-fill.svg": [
		91684,
		91684
	],
	"./bookmark.svg": [
		79210,
		79210
	],
	"./box-check.svg": [
		49622,
		49622
	],
	"./box-dashed.svg": [
		69785,
		69785
	],
	"./box-inset.svg": [
		27281,
		27281
	],
	"./box.svg": [
		58113,
		58113
	],
	"./boxes-arrow-fill.svg": [
		36305,
		36305
	],
	"./boxes-arrow.svg": [
		11445,
		11445
	],
	"./briefcase.svg": [
		3158,
		3158
	],
	"./brush-2.svg": [
		58787,
		58787
	],
	"./brush-fill.svg": [
		70012,
		70012
	],
	"./brush.svg": [
		51890,
		51890
	],
	"./bullet-list.svg": [
		18923,
		18923
	],
	"./calendar-fill.svg": [
		72050,
		72050
	],
	"./calendar-flag-fill.svg": [
		17223,
		17223
	],
	"./calendar-flag.svg": [
		27211,
		27211
	],
	"./calendar-lock-fill.svg": [
		70498,
		70498
	],
	"./calendar-lock.svg": [
		84648,
		84648
	],
	"./calendar-plus-fill.svg": [
		54389,
		54389
	],
	"./calendar-plus.svg": [
		74993,
		74993
	],
	"./calendar.svg": [
		12536,
		12536
	],
	"./camera-off.svg": [
		39271,
		39271
	],
	"./camera.svg": [
		14863,
		14863
	],
	"./cards-fill.svg": [
		61907,
		61907
	],
	"./cards.svg": [
		76207,
		76207
	],
	"./cast.svg": [
		98519,
		98519
	],
	"./caution-circle.svg": [
		88170,
		88170
	],
	"./caution-octagon.svg": [
		39723,
		39723
	],
	"./caution-square.svg": [
		69807,
		69807
	],
	"./caution-triangle.svg": [
		38962,
		38962
	],
	"./caution.svg": [
		39453,
		39453
	],
	"./certificate-fill.svg": [
		93015,
		93015
	],
	"./certificate.svg": [
		40827,
		40827
	],
	"./chat-bubble-check-fill.svg": [
		14570,
		14570
	],
	"./chat-bubble-check.svg": [
		22368,
		22368
	],
	"./chat-bubble-ellipses-fill.svg": [
		64073,
		64073
	],
	"./chat-bubble-ellipses.svg": [
		35709,
		35709
	],
	"./chat-bubble-plus-fill.svg": [
		86594,
		86594
	],
	"./chat-bubble-plus.svg": [
		6376,
		6376
	],
	"./chat-bubble.svg": [
		32063,
		32063
	],
	"./chat-bubbles-fill.svg": [
		95600,
		95600
	],
	"./chat-bubbles.svg": [
		91230,
		91230
	],
	"./check-circle-fill.svg": [
		36227,
		36227
	],
	"./check-circle-inset-dashed.svg": [
		45175,
		45175
	],
	"./check-circle-inset-fill.svg": [
		33275,
		33275
	],
	"./check-circle.svg": [
		3871,
		3871
	],
	"./check-dash-circle.svg": [
		30608,
		30608
	],
	"./check-dash-square.svg": [
		74969,
		74969
	],
	"./check-dash.svg": [
		56627,
		56627
	],
	"./check-list.svg": [
		77671,
		77671
	],
	"./check-square.svg": [
		73710,
		73710
	],
	"./check.svg": [
		32210,
		32210
	],
	"./checklist-square.svg": [
		43066,
		43066
	],
	"./checkmark-thick.svg": [
		77013,
		77013
	],
	"./chevron-down-circle-fill.svg": [
		42289,
		42289
	],
	"./chevron-down-circle.svg": [
		66933,
		66933
	],
	"./chevron-down-square.svg": [
		78792,
		78792
	],
	"./chevron-down.svg": [
		81416,
		81416
	],
	"./chevron-left-circle-fill.svg": [
		96102,
		96102
	],
	"./chevron-left-circle.svg": [
		64900,
		64900
	],
	"./chevron-left-square.svg": [
		75981,
		75981
	],
	"./chevron-left.svg": [
		22311,
		22311
	],
	"./chevron-right-circle-fill.svg": [
		95347,
		95347
	],
	"./chevron-right-circle.svg": [
		6415,
		6415
	],
	"./chevron-right-square.svg": [
		55326,
		55326
	],
	"./chevron-right.svg": [
		19874,
		19874
	],
	"./chevron-up-circle-fill.svg": [
		74450,
		74450
	],
	"./chevron-up-circle.svg": [
		98456,
		98456
	],
	"./chevron-up-square.svg": [
		72129,
		72129
	],
	"./chevron-up.svg": [
		76763,
		76763
	],
	"./chevrons-down.svg": [
		80019,
		80019
	],
	"./chevrons-left.svg": [
		2564,
		2564
	],
	"./chevrons-right.svg": [
		35211,
		35211
	],
	"./chevrons-up.svg": [
		54316,
		54316
	],
	"./chrome.svg": [
		55476,
		55476
	],
	"./church.svg": [
		42095,
		42095
	],
	"./circle-3-4-inset-fill.svg": [
		2337,
		2337
	],
	"./circle-fill.svg": [
		67284,
		67284
	],
	"./circle-half-inset-fill.svg": [
		45134,
		45134
	],
	"./circle.svg": [
		48602,
		48602
	],
	"./clipboard.svg": [
		10848,
		10848
	],
	"./clock-fill.svg": [
		36130,
		36130
	],
	"./clock.svg": [
		77800,
		77800
	],
	"./cloud-arrows-fill.svg": [
		43070,
		43070
	],
	"./cloud-arrows.svg": [
		85196,
		85196
	],
	"./cloud-asterisk-fill.svg": [
		78948,
		78948
	],
	"./cloud-asterisk.svg": [
		85322,
		85322
	],
	"./cloud-down-fill.svg": [
		52976,
		52976
	],
	"./cloud-down.svg": [
		22270,
		22270
	],
	"./cloud-drizzle.svg": [
		66376,
		66376
	],
	"./cloud-fill.svg": [
		73637,
		73637
	],
	"./cloud-key-fill.svg": [
		73399,
		73399
	],
	"./cloud-key.svg": [
		26171,
		26171
	],
	"./cloud-lightning.svg": [
		93352,
		93352
	],
	"./cloud-notification-fill.svg": [
		10719,
		10719
	],
	"./cloud-notification.svg": [
		37235,
		37235
	],
	"./cloud-off.svg": [
		37333,
		37333
	],
	"./cloud-rain.svg": [
		17400,
		17400
	],
	"./cloud-snow.svg": [
		50287,
		50287
	],
	"./cloud-up-fill.svg": [
		99665,
		99665
	],
	"./cloud-up.svg": [
		2005,
		2005
	],
	"./cloud-x-fill.svg": [
		78044,
		78044
	],
	"./cloud-x.svg": [
		13618,
		13618
	],
	"./cloud.svg": [
		98817,
		98817
	],
	"./code-square.svg": [
		69659,
		69659
	],
	"./code.svg": [
		66345,
		66345
	],
	"./coffee.svg": [
		40278,
		40278
	],
	"./cohort-arrow-fill.svg": [
		3777,
		3777
	],
	"./cohort-arrow.svg": [
		97285,
		97285
	],
	"./cohort-fill.svg": [
		37029,
		37029
	],
	"./cohort.svg": [
		58305,
		58305
	],
	"./collapse-2.svg": [
		51366,
		51366
	],
	"./collapse.svg": [
		48179,
		48179
	],
	"./columns-1-fill.svg": [
		55269,
		55269
	],
	"./columns-2-fill.svg": [
		48092,
		48092
	],
	"./columns-3-fill.svg": [
		33743,
		33743
	],
	"./command.svg": [
		81829,
		81829
	],
	"./compass-2.svg": [
		6047,
		6047
	],
	"./compass-3.svg": [
		77614,
		77614
	],
	"./compass.svg": [
		98838,
		98838
	],
	"./computer-frown.svg": [
		60334,
		60334
	],
	"./computer-smile.svg": [
		63578,
		63578
	],
	"./connections.svg": [
		45873,
		45873
	],
	"./copy.svg": [
		2345,
		2345
	],
	"./credit-card.svg": [
		67368,
		67368
	],
	"./css.svg": [
		56415,
		56415
	],
	"./cursor.svg": [
		91396,
		91396
	],
	"./delete.svg": [
		20683,
		20683
	],
	"./device.svg": [
		21544,
		21544
	],
	"./devices.svg": [
		27643,
		27643
	],
	"./dollar-sign-arrows.svg": [
		36329,
		36329
	],
	"./download-blocked.svg": [
		13773,
		13773
	],
	"./download.svg": [
		41722,
		41722
	],
	"./drag-drop-fill.svg": [
		68212,
		68212
	],
	"./drag-drop.svg": [
		48346,
		48346
	],
	"./drag.svg": [
		93872,
		93872
	],
	"./edit-2.svg": [
		15759,
		15759
	],
	"./edit-circle-fill.svg": [
		23439,
		23439
	],
	"./edit-plus.svg": [
		18159,
		18159
	],
	"./edit.svg": [
		56614,
		56614
	],
	"./ellipses-horizontal.svg": [
		49896,
		49896
	],
	"./ellipses-o.svg": [
		47919,
		47919
	],
	"./ellipses-vertical.svg": [
		36670,
		36670
	],
	"./envelope-fill.svg": [
		47428,
		47428
	],
	"./envelope.svg": [
		17898,
		17898
	],
	"./expand-2.svg": [
		22343,
		22343
	],
	"./expand.svg": [
		13134,
		13134
	],
	"./external-link.svg": [
		57240,
		57240
	],
	"./eye-bowie.svg": [
		14484,
		14484
	],
	"./eye-lock-fill.svg": [
		61319,
		61319
	],
	"./eye-lock.svg": [
		27947,
		27947
	],
	"./eye-off.svg": [
		95329,
		95329
	],
	"./eye.svg": [
		21789,
		21789
	],
	"./eyes.svg": [
		38644,
		38644
	],
	"./facebook.svg": [
		11254,
		11254
	],
	"./fastforward-fill.svg": [
		36103,
		36103
	],
	"./fastforward-inset-circle-fill.svg": [
		87226,
		87226
	],
	"./fastforward-inset-circle.svg": [
		42832,
		42832
	],
	"./fastforward.svg": [
		79467,
		79467
	],
	"./feedback-fill.svg": [
		58939,
		58939
	],
	"./feedback.svg": [
		65063,
		65063
	],
	"./file-audio.svg": [
		68561,
		68561
	],
	"./file-code.svg": [
		9346,
		9346
	],
	"./file-fill.svg": [
		39674,
		39674
	],
	"./file-image.svg": [
		63036,
		63036
	],
	"./file-text.svg": [
		31968,
		31968
	],
	"./file-video.svg": [
		90838,
		90838
	],
	"./file-zipped.svg": [
		55529,
		55529
	],
	"./file.svg": [
		18096,
		18096
	],
	"./files.svg": [
		1587,
		1587
	],
	"./flag-fill.svg": [
		30738,
		30738
	],
	"./flag.svg": [
		13112,
		13112
	],
	"./flip-horizontal.svg": [
		37528,
		37528
	],
	"./flip-vertical.svg": [
		78990,
		78990
	],
	"./folder.svg": [
		50306,
		50306
	],
	"./frown.svg": [
		45418,
		45418
	],
	"./gauge-circle.svg": [
		52596,
		52596
	],
	"./gauge-square.svg": [
		33757,
		33757
	],
	"./gauge.svg": [
		35607,
		35607
	],
	"./gear-dollar-sign.svg": [
		7596,
		7596
	],
	"./gear-fill-2.svg": [
		10850,
		10850
	],
	"./gear.svg": [
		29339,
		29339
	],
	"./gears.svg": [
		85458,
		85458
	],
	"./gem.svg": [
		68135,
		68135
	],
	"./glasses-fill.svg": [
		65840,
		65840
	],
	"./glasses.svg": [
		36030,
		36030
	],
	"./globe-fill.svg": [
		51661,
		51661
	],
	"./globe-hands-fill.svg": [
		47790,
		47790
	],
	"./globe-hands.svg": [
		84028,
		84028
	],
	"./globe.svg": [
		30073,
		30073
	],
	"./google-logo.svg": [
		80277,
		80277
	],
	"./grad-cap.svg": [
		70893,
		70893
	],
	"./grid-large-fill.svg": [
		92226,
		92226
	],
	"./grid-large.svg": [
		13064,
		13064
	],
	"./grid-small-fill.svg": [
		86554,
		86554
	],
	"./grid-small.svg": [
		98320,
		98320
	],
	"./group-2.svg": [
		26966,
		26966
	],
	"./group-3-fill.svg": [
		65883,
		65883
	],
	"./group-3.svg": [
		90183,
		90183
	],
	"./group-lock.svg": [
		54177,
		54177
	],
	"./group-plus.svg": [
		16348,
		16348
	],
	"./group-stack.svg": [
		22132,
		22132
	],
	"./group.svg": [
		96611,
		96611
	],
	"./happy-avatars-square-fill.svg": [
		18651,
		18651
	],
	"./happy-avatars-square.svg": [
		28231,
		28231
	],
	"./heading.svg": [
		29032,
		29032
	],
	"./headphones.svg": [
		32503,
		32503
	],
	"./heart-fill.svg": [
		86544,
		86544
	],
	"./heart.svg": [
		21630,
		21630
	],
	"./house-fill.svg": [
		70924,
		70924
	],
	"./house.svg": [
		22786,
		22786
	],
	"./image-gallery.svg": [
		82092,
		82092
	],
	"./image.svg": [
		40473,
		40473
	],
	"./inbox-fill.svg": [
		29980,
		29980
	],
	"./inbox-in.svg": [
		13950,
		13950
	],
	"./inbox.svg": [
		4850,
		4850
	],
	"./infinity.svg": [
		73138,
		73138
	],
	"./info-circle.svg": [
		67439,
		67439
	],
	"./info-square.svg": [
		8094,
		8094
	],
	"./info.svg": [
		23426,
		23426
	],
	"./instagram.svg": [
		37970,
		37970
	],
	"./integration-2.svg": [
		88533,
		88533
	],
	"./integration-smile.svg": [
		54091,
		54091
	],
	"./integration.svg": [
		40760,
		40760
	],
	"./italic.svg": [
		55574,
		55574
	],
	"./key.svg": [
		32647,
		32647
	],
	"./keys.svg": [
		43638,
		43638
	],
	"./layout-1.svg": [
		55166,
		55166
	],
	"./layout-2-fill.svg": [
		15177,
		15177
	],
	"./layout-2.svg": [
		67261,
		67261
	],
	"./layout-blocks.svg": [
		1291,
		1291
	],
	"./lesson.svg": [
		83366,
		83366
	],
	"./life-saver.svg": [
		73836,
		73836
	],
	"./lightbulb-fill.svg": [
		93295,
		93295
	],
	"./lightbulb-on-fill.svg": [
		16307,
		16307
	],
	"./lightbulb-on.svg": [
		68751,
		68751
	],
	"./lightbulb.svg": [
		44355,
		44355
	],
	"./link-2.svg": [
		84555,
		84555
	],
	"./link.svg": [
		72906,
		72906
	],
	"./linkedin.svg": [
		9652,
		9652
	],
	"./list-back.svg": [
		35078,
		35078
	],
	"./list-one-column-fill.svg": [
		86630,
		86630
	],
	"./list-one-column.svg": [
		11556,
		11556
	],
	"./list-two-column-fill.svg": [
		3228,
		3228
	],
	"./list-two-column.svg": [
		87442,
		87442
	],
	"./list.svg": [
		18622,
		18622
	],
	"./location-large.svg": [
		9773,
		9773
	],
	"./location-small.svg": [
		81717,
		81717
	],
	"./location.svg": [
		57367,
		57367
	],
	"./lock-circle.svg": [
		46744,
		46744
	],
	"./lock-inset-circle.svg": [
		68800,
		68800
	],
	"./lock-square.svg": [
		1761,
		1761
	],
	"./lock.svg": [
		38235,
		38235
	],
	"./map-fill-alt.svg": [
		56600,
		56600
	],
	"./map-fill.svg": [
		45018,
		45018
	],
	"./map.svg": [
		73808,
		73808
	],
	"./markdown.svg": [
		83889,
		83889
	],
	"./maximize-2.svg": [
		51993,
		51993
	],
	"./maximize.svg": [
		84868,
		84868
	],
	"./meh.svg": [
		82604,
		82604
	],
	"./minimize-2.svg": [
		95635,
		95635
	],
	"./minimize.svg": [
		25026,
		25026
	],
	"./minus-circle-fill.svg": [
		25671,
		25671
	],
	"./minus-circle.svg": [
		41259,
		41259
	],
	"./minus-square.svg": [
		40458,
		40458
	],
	"./minus.svg": [
		81006,
		81006
	],
	"./moon.svg": [
		83809,
		83809
	],
	"./multi-user.svg": [
		8323,
		8323
	],
	"./nested-list.svg": [
		1204,
		1204
	],
	"./newspaper.svg": [
		6343,
		6343
	],
	"./note-add.svg": [
		22316,
		22316
	],
	"./note-lock.svg": [
		57782,
		57782
	],
	"./note.svg": [
		7118,
		7118
	],
	"./noted-edit-fill.svg": [
		65311,
		65311
	],
	"./notes-edit.svg": [
		42418,
		42418
	],
	"./notes-fill.svg": [
		51669,
		51669
	],
	"./notes.svg": [
		68401,
		68401
	],
	"./oven-fill.svg": [
		12418,
		12418
	],
	"./oven.svg": [
		76808,
		76808
	],
	"./overlapping-squares-fill.svg": [
		1094,
		1094
	],
	"./overlapping-squares.svg": [
		1636,
		1636
	],
	"./paper-airplane-2-fill.svg": [
		82928,
		82928
	],
	"./paper-airplane-2.svg": [
		78398,
		78398
	],
	"./paper-airplane-fill.svg": [
		99895,
		99895
	],
	"./paper-airplane.svg": [
		83419,
		83419
	],
	"./paper-clip.svg": [
		82307,
		82307
	],
	"./password.svg": [
		43913,
		43913
	],
	"./paste.svg": [
		40043,
		40043
	],
	"./path-italic.svg": [
		61840,
		61840
	],
	"./path-roman.svg": [
		10239,
		10239
	],
	"./path.svg": [
		9367,
		9367
	],
	"./paths-italic.svg": [
		81095,
		81095
	],
	"./paths-roman.svg": [
		57902,
		57902
	],
	"./paths.svg": [
		36486,
		36486
	],
	"./pause.svg": [
		79200,
		79200
	],
	"./phone.svg": [
		88610,
		88610
	],
	"./pie-chart.svg": [
		13335,
		13335
	],
	"./pin-2.svg": [
		73474,
		73474
	],
	"./pin-fill-2.svg": [
		78830,
		78830
	],
	"./pin-fill.svg": [
		8555,
		8555
	],
	"./pin.svg": [
		55639,
		55639
	],
	"./pinterest.svg": [
		38920,
		38920
	],
	"./pizza.svg": [
		78048,
		78048
	],
	"./play.svg": [
		74408,
		74408
	],
	"./plus-circle-fill.svg": [
		15567,
		15567
	],
	"./plus-circle.svg": [
		80291,
		80291
	],
	"./plus-square.svg": [
		40866,
		40866
	],
	"./plus.svg": [
		69030,
		69030
	],
	"./pointer-fill.svg": [
		69273,
		69273
	],
	"./pointer.svg": [
		52333,
		52333
	],
	"./printer.svg": [
		38374,
		38374
	],
	"./qr-code.svg": [
		30759,
		30759
	],
	"./question-mark-fill.svg": [
		77606,
		77606
	],
	"./question-mark.svg": [
		28900,
		28900
	],
	"./quote-marks.svg": [
		84019,
		84019
	],
	"./radar.svg": [
		29370,
		29370
	],
	"./recur-pause.svg": [
		7136,
		7136
	],
	"./recur-smile.svg": [
		606,
		606
	],
	"./recur-x.svg": [
		59462,
		59462
	],
	"./recur.svg": [
		95533,
		95533
	],
	"./rewind.svg": [
		60535,
		60535
	],
	"./rocket.svg": [
		84618,
		84618
	],
	"./rss.svg": [
		91126,
		91126
	],
	"./scissors.svg": [
		18567,
		18567
	],
	"./seal-arrow-back.svg": [
		69991,
		69991
	],
	"./seal-check.svg": [
		57302,
		57302
	],
	"./search-list.svg": [
		47463,
		47463
	],
	"./search-location-fill.svg": [
		85592,
		85592
	],
	"./search-location.svg": [
		65558,
		65558
	],
	"./search.svg": [
		42130,
		42130
	],
	"./settings-horizontal.svg": [
		69346,
		69346
	],
	"./settings-vertical.svg": [
		17296,
		17296
	],
	"./shapes-fill.svg": [
		10890,
		10890
	],
	"./shapes.svg": [
		98048,
		98048
	],
	"./share-fill.svg": [
		907,
		907
	],
	"./share.svg": [
		14839,
		14839
	],
	"./shopping-bag-fill.svg": [
		47151,
		47151
	],
	"./shopping-bag.svg": [
		97155,
		97155
	],
	"./shuffle.svg": [
		3229,
		3229
	],
	"./sidebar-bottom.svg": [
		99846,
		99846
	],
	"./sidebar-fill.svg": [
		52584,
		52584
	],
	"./sidebar-side.svg": [
		36282,
		36282
	],
	"./sidebar.svg": [
		49926,
		49926
	],
	"./signature.svg": [
		43740,
		43740
	],
	"./skip-back-2.svg": [
		34736,
		34736
	],
	"./skip-back.svg": [
		42713,
		42713
	],
	"./skip-circle.svg": [
		96292,
		96292
	],
	"./skip-forward-2.svg": [
		3410,
		3410
	],
	"./skip-forward.svg": [
		83239,
		83239
	],
	"./skip-square.svg": [
		81421,
		81421
	],
	"./skip.svg": [
		79847,
		79847
	],
	"./slash.svg": [
		74105,
		74105
	],
	"./smile.svg": [
		94718,
		94718
	],
	"./spacing-horizontal-large.svg": [
		90776,
		90776
	],
	"./spacing-horizontal-medium.svg": [
		63022,
		63022
	],
	"./spacing-horizontal-small.svg": [
		12512,
		12512
	],
	"./spacing-vertical-large.svg": [
		87654,
		87654
	],
	"./spacing-vertical-medium.svg": [
		50048,
		50048
	],
	"./spacing-vertical-small.svg": [
		3642,
		3642
	],
	"./sparkles.svg": [
		97363,
		97363
	],
	"./squares-maximize.svg": [
		93173,
		93173
	],
	"./stack-fill.svg": [
		18700,
		18700
	],
	"./stack.svg": [
		63586,
		63586
	],
	"./star-half.svg": [
		23072,
		23072
	],
	"./star.svg": [
		93474,
		93474
	],
	"./step.svg": [
		68708,
		68708
	],
	"./stop.svg": [
		88314,
		88314
	],
	"./storefront.svg": [
		63658,
		63658
	],
	"./sun.svg": [
		24432,
		24432
	],
	"./swatches.svg": [
		8138,
		8138
	],
	"./tag-dollar-sign-fill.svg": [
		95513,
		95513
	],
	"./tag-dollar-sign.svg": [
		23533,
		23533
	],
	"./tag-fill.svg": [
		84972,
		84972
	],
	"./tag.svg": [
		47042,
		47042
	],
	"./test-tube.svg": [
		85209,
		85209
	],
	"./text-align-center.svg": [
		69403,
		69403
	],
	"./text-align-justified.svg": [
		79899,
		79899
	],
	"./text-align-left.svg": [
		73283,
		73283
	],
	"./text-align-right.svg": [
		74342,
		74342
	],
	"./text-box-2.svg": [
		97678,
		97678
	],
	"./text-box.svg": [
		86923,
		86923
	],
	"./text-cursor.svg": [
		76422,
		76422
	],
	"./text-edit.svg": [
		8748,
		8748
	],
	"./text-reading.svg": [
		90540,
		90540
	],
	"./thread.svg": [
		2990,
		2990
	],
	"./thumbprint-key-horizontal.svg": [
		25762,
		25762
	],
	"./thumbprint-key-vertical.svg": [
		24336,
		24336
	],
	"./thumbprint.svg": [
		15099,
		15099
	],
	"./todo-cards-fill.svg": [
		6714,
		6714
	],
	"./toolbox.svg": [
		83843,
		83843
	],
	"./trash-fill.svg": [
		66126,
		66126
	],
	"./trash-undo-fill.svg": [
		35627,
		35627
	],
	"./trash-undo.svg": [
		36439,
		36439
	],
	"./trash.svg": [
		60380,
		60380
	],
	"./triangle-down.svg": [
		23483,
		23483
	],
	"./triangle-large.svg": [
		15712,
		15712
	],
	"./triangle-small.svg": [
		6184,
		6184
	],
	"./triangle-up.svg": [
		43892,
		43892
	],
	"./triangles-2.svg": [
		84188,
		84188
	],
	"./triangles.svg": [
		13245,
		13245
	],
	"./twitter.svg": [
		91491,
		91491
	],
	"./unlock-circle.svg": [
		92427,
		92427
	],
	"./unlock-square.svg": [
		7978,
		7978
	],
	"./unlock.svg": [
		8302,
		8302
	],
	"./upload.svg": [
		49993,
		49993
	],
	"./url-square.svg": [
		22855,
		22855
	],
	"./url.svg": [
		46133,
		46133
	],
	"./video.svg": [
		27263,
		27263
	],
	"./vimeo.svg": [
		47850,
		47850
	],
	"./volume-down.svg": [
		6313,
		6313
	],
	"./volume-up.svg": [
		18086,
		18086
	],
	"./wand.svg": [
		33860,
		33860
	],
	"./whistle.svg": [
		93348,
		93348
	],
	"./window-smile-fill.svg": [
		90025,
		90025
	],
	"./window-smile.svg": [
		21277,
		21277
	],
	"./window.svg": [
		55718,
		55718
	],
	"./x-circle-fill.svg": [
		16495,
		16495
	],
	"./x-circle.svg": [
		64835,
		64835
	],
	"./x-square.svg": [
		64802,
		64802
	],
	"./x-thick.svg": [
		26282,
		26282
	],
	"./x.svg": [
		78374,
		78374
	],
	"./youtube.svg": [
		68585,
		68585
	],
	"./zoom-in.svg": [
		1365,
		1365
	],
	"./zoom-out.svg": [
		67084,
		67084
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 20205;
module.exports = webpackAsyncContext;